import { EmailVerificationRequiredForm } from "./EmailVerificationRequiredForm";

export const EmailVerificationRequiredPage = () => {
  return <EmailVerificationRequiredForm />;
};
